import ClientMarginsList from "./ClientMarginsList";

export default ClientMarginsList;
